import { fromJS } from 'immutable';
import packageInfo from '../package.json';

export const UPDATE_INAUTH_UUID = `modules/${packageInfo.name}/UPDATE_INAUTH_UUID`;
export const UPDATE_BC_UUID = `modules/${packageInfo.name}/UPDATE_BC_UUID`;
export const SET_UPDATE_DDL_VIEW = `modules/${packageInfo.name}/SET_UPDATE_DDL_VIEW`;
export const SET_INAV_DATA = `modules/${packageInfo.name}/SET_INAV_DATA`;

const buildInitialState = (data = {}) => {
  const query = data?.req?.query || {};
  const postBody = data?.req?.body || {};
  return fromJS({ query, postBody });
};

function reducer(state = buildInitialState(), action = {}) {
  switch (action.type) {
    case UPDATE_INAUTH_UUID: {
      return state.merge({ inAuthUUID: action.payload });
    }
    case UPDATE_BC_UUID: {
      return state.merge({ bcUUID: action.payload });
    }
    case SET_UPDATE_DDL_VIEW: {
      return state.merge({ updateViewData: action.payload });
    }
    case SET_INAV_DATA: {
      return state.merge({ inavDetails: action.payload });
    }
    default:
      return state;
  }
}

reducer.buildInitialState = buildInitialState;

function setInAuthUUID(uuid) {
  return { type: UPDATE_INAUTH_UUID, payload: uuid };
}

function setBiocatchUUID(uuid) {
  return { type: UPDATE_BC_UUID, payload: uuid };
}

function setUpdateViewDDL(updateViewData) {
  return { type: SET_UPDATE_DDL_VIEW, payload: updateViewData };
}

function setInavData(inavData) {
  return { type: SET_INAV_DATA, payload: inavData };
}

const mapDispatchToProps = (dispatch) => ({
  actSetInAuthUUID: (...args) => dispatch(setInAuthUUID(...args)),
  actSetBiocatchUUID: (...args) => dispatch(setBiocatchUUID(...args)),
  actSetUpdateViewDDL: (...args) => dispatch(setUpdateViewDDL(...args)),
  actSetInavData: (...args) => dispatch(setInavData(...args)),
});

export {
  buildInitialState,
  reducer,
  mapDispatchToProps,
};
